import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
export interface TrendIndicatorProps {
  value: number;
  label?: string;
  direction: 'up' | 'down';
  inverse?: boolean;
}
export function TrendIndicator({
  value,
  label = '',
  direction,
  inverse = false
}: TrendIndicatorProps) {
  // Determine if this is a positive trend
  const isPositive = inverse ? direction === 'down' : direction === 'up';
  const colorClass = isPositive ? 'text-[#10B981]' : 'text-[#EF4444]';
  const Icon = direction === 'up' ? TrendingUp : TrendingDown;
  return <div className={`flex items-center gap-1 text-xs ${colorClass}`} data-id="element-3948">
      <Icon className="w-3 h-3" data-id="element-3949" />
      <span className="font-medium" data-id="element-3950">{value}%</span>
      {label && <span className="text-[#64748B]" data-id="element-3951">{label}</span>}
    </div>;
}